import Image from 'next/image'
import React from 'react'

interface NoImageProps { 
    image: any,
    width: number,
    height: number

}

export const NoImage = ({image, width, height} : NoImageProps) => {
  return (
    <Image src={image} width={width} height={height} alt='no-image'/>
  )
}
